import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jiantou_zuo",
  "use": "icon-jiantou_zuo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiantou_zuo\"><defs><style type=\"text/css\"></style></defs><path d=\"M272.448 472.064l399.232-399.232c22.080-22.080 57.792-22.080 79.872 0 22.016 22.016 22.080 57.792 0 79.872l-359.296 359.296 359.296 359.296c22.016 22.016 22.080 57.792 0 79.872s-57.792 22.016-79.872 0l-399.232-399.232c-22.016-22.080-22.016-57.792 0-79.872z\" p-id=\"6541\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol